export enum InventoryDestructionMethod {
  ERASE = "ERASE",
  SHRED = "SHRED",
}
